var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.pageClass},[_c('div',{class:_vm.pageModeClass},[(_vm.scrollTurnPage)?_c('vertical-page'):_vm._e()],1),_c('tool-bar',{attrs:{"show":_vm.$store.state.showToolbar}}),_c('contents-popup',{attrs:{"show":_vm.contentsStatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }